module.exports = __webpack_public_path__ + "static/semantic-placeholder-content-image-529070d2e67e2cdf3f2b0842d358b6b2.gif";